<template>
  <div id="app">
    <div v-if="!$auth.ready()">Site loading...</div>
    <layout-welcome v-if="$auth.ready() && !$auth.check()" />
    <layout-main v-if="$auth.ready() && $auth.check()" />
  </div>
</template>

<script>
import LayoutWelcome from "@/layouts/LayoutWelcome.vue";
import LayoutMain from "@/layouts/LayoutMain.vue";

export default {
  components: {
    LayoutWelcome,
    LayoutMain
  },
  data: function() {
    return {};
  },
  methods: {

  }
};
</script>


<style lang="scss">
@import './assets/scss/main.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>
